import Vue from 'vue';
import Router from 'vue-router';
import routerInfo from './router';
import App from './App.vue';
import store from './store';
import { rem, vueTap, initReport, user, request } from '@tencent/ppd-base-libs';
import axios from 'axios';
import { isInWeixin } from '@/utils/index';
import { ERouterName } from './config/constants';
import { plugin } from '@tencent/fit-bi-sdk';
import MtaConfigGlobal from '@/mta-config-global';

request.init(axios);

user.setUinKey('ia_charity_qluin');

// 处理路由信息
Vue.use(Router);
const router = new Router(routerInfo);

// bi工具初始化代码，请注意使用 bi-cli 生成 mta-config-global.ts 后，引入到项目中，并在main.ts中初始化
Vue.use(plugin, {
  ...MtaConfigGlobal,
  route: router,
});

// 如果是端外打开的，那么重定向到中转页
router.beforeEach((to, from, next) => {
  console.log(to.name, from, isInWeixin());

  if (!isInWeixin() && to.name !== ERouterName.outsideWx) {
    next({
      path: `/${ERouterName.outsideWx}`,
    });
  } else {
    next();
  }
  // next();
});

initReport({
  router,
  // @ts-ignore
  appEnv: process.env.VUE_APP_ENV,
  // @ts-ignore
  business: process.env.VUE_APP_PKGNAME,  // 区分业务，用于elk
  isReportPageStayedTime: true, // 是否上报页面停留时间
  sentry: {
    dsn: 'https://821c073fa75a4e368182795f4d355f33@report.url.cn/sentry/2389',
    // webpack变异全局变量
    // @ts-ignore
    release: process.env.VUE_APP_SENTRY_VERSION,
  },
  bi: {
    reportNeedLogin: true,
  },
}, Vue);

// 开启rem布局
rem();
// 开启vtap
Vue.use(vueTap);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
